export default {
	STRAPI_URL: process.env.VUE_APP_STRAPI_URL,
	MEILISEARCH_URL: process.env.VUE_APP_MEILISEARCH_URL,
	MEILISEARCH_MASTER_KEY: process.env.VUE_APP_MEILISEARCH_MASTER_KEY,
	STRAPI_TOKEN: process.env.VUE_APP_STRAPI_API_TOKEN,
}